import * as actionTypes from '../actionTypes';

export default (state, action) => {
  switch (action.type) {
    case actionTypes.PROCESS_START:
      console.log('loaded');
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.FETCH_RECORDS:
      return {
        ...state,
        loading: false,
        error: null,
        dues: action.payload.data,
        total: action.payload.total,
        totalAmount: action.payload.totalAmount
      };

    case 'LOAD_DUE':
      return {
        ...state,
        load: false,
      };

    case actionTypes.FETCH_RECORD:
      return {
        ...state,
        load: true,
        due: action.payload,
      };

    case actionTypes.ADD_RECORD:
      return {
        ...state,
        // due: [action.payload.data, ...state.due],
        submitteData: action.payload.data,
        due: [...state.due.filter((el) => el !== action.payload.data)],
        // total: state.total + 1,
      };

    case actionTypes.FETCH_ERRORS:
      return {
        ...state,
        load: false,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
